<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { ACTIONS, dispatch } from '@/store';
import { getUrlParam } from '@/utils';
import { STORAGE } from '@/utils/const';
export default {
  name: "app",
  components: {
  },
  data(){
    return {
    };
  },
  mounted() {
    this.queryResource();
  },
  methods: {
    queryResource() {
      let bizType = getUrlParam('bizType');
      let resourceDataStorage = JSON.parse(localStorage.getItem(STORAGE.RJ_RESOURCE_INFO) || '{}');
      if (bizType || !Object.keys(resourceDataStorage).length) {
        dispatch(ACTIONS.queryResource, {
          bizType: bizType || 'default', cb: (dataObj) => {
            document.title = dataObj.sysName ? dataObj.sysName.resourceData : '睿媒AI识谣平台';
          }
        });
      } else {
        document.title = resourceDataStorage.sysName ? resourceDataStorage.sysName.resourceData : '睿媒AI识谣平台';
      }
    }
  }
};
</script>

<style lang="less">
  #app {
    > div {
      font-size: 14px;
    }
  }
</style>